<template>
  <div class="sa-free-page">
    <div class="sa-free-page-header">
      <b-row no-gutters v-if="!hideTitleDiv">
        <b-col @click="goToStep(index)" :style="[{ width: 100 / steps.length + '%' }, { cursor: 'pointer' }]"
          :class="['ft-step', { 'active-class-step': index + 1 === stepper }]" v-for="(step, index) in steps"
          :key="step">
          <span class="ft-step-name">{{ step }}</span>
        </b-col>
        <b-col cols="12" :style="{ padding: '12px' }">
          <b-progress :max="steps.length" :value="stepper" show-progress animated class="mb-3"></b-progress>
        </b-col>
        <b-col cols="12">
          <div class="text-right">
            <b-button v-if="!isFirstStep" variant="secondary" @click="prevStep">Indietro</b-button>
            <b-button v-if="!isLastStep && btnAvantiDefault" variant="primary" class="ml-3"
              @click="nextStep">Avanti</b-button>
            <b-button v-if="isLastStep && btnSaveDeafult" variant="success"
              @click="confermaDatiSteps">Conferma</b-button>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="sa-free-page-body">
      <slot v-if="$slots[`step-${stepper}`]" :name="`step-${stepper}`"></slot>
      <slot v-else>No Slot Defined per {{ stepper }}</slot>
    </div>
    <div class="sa-free-page-footer">
      <div class="text-right">
        <b-button v-if="!isFirstStep" variant="secondary" @click="prevStep" class="mr-2">Indietro</b-button>
        <slot :name="`btn-section-step-${stepper}`"></slot>
        <b-button v-if="!isLastStep && btnAvantiDefault" variant="primary" @click="nextStep">Avanti</b-button>
        <b-button v-if="isLastStep && btnSaveDeafult" variant="success" @click="confermaDatiSteps">{{ btnSaveTitleString
        }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initStepper: {
      type: Number,
      require: false,
      default: () => {
        return 1;
      },
    },
    steps: {
      type: Array,
      require: true,
      default: () => {
        return [];
      },
    },
    btnSaveDeafult: {
      type: Boolean,
      require: false,
      default: () => {
        return false;
      },
    },
    btnSaveTitleString: {
      type: String,
      require: false,
      default: () => {
        return "Conferma";
      },
    },
    btnAvantiDefault: {
      type: Boolean,
      require: false,
      default: () => {
        return true;
      },
    },
    hideTitleDiv: {
      type: Boolean,
      require: false,
      default: () => {
        return false;
      },
    },
  },
  mounted() {
    let me = this;
    if (me.initStepper > 1) {
      me.stepper = me.initStepper;
    }
  },

  data() {
    return {
      stepper: 1,
    };
  },
  computed: {
    isLastStep() {
      return this.stepper == this.steps.length;
    },
    isFirstStep() {
      return this.stepper == 1;
    },
  },
  methods: {
    nextStep() {
      let me = this;
      if (me.stepper < me.steps.length) {
        me.stepper++;
      }
    },
    prevStep() {
      let me = this;
      if (me.stepper > 1) {
        me.stepper--;
      }
    },
    confermaDatiSteps() {
      let me = this;
      me.$emit("salva");
    },
    goToStep(step) {
      let stepi = step + 1;
      this.stepper = stepi;
    },
  },
  watch: {
    initStepper: function (params) {
      let me = this;
      me.stepper = params;
    },
    stepper: function (params) {
      let me = this;
      me.$emit("stepperUpdated", params);
    },
  },
};
</script>

<style lang="scss" scoped>
.active-class-step {
  border: 2px solid rgb(21, 155, 207) !important;
  background-color: white;
  border-radius: 50%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(21, 155, 207) !important;
  box-shadow: 0 0 10px rgba(21, 155, 207, 0.3);
  transition: all 0.2s ease-in-out;
}

.ft-step {
  font-weight: 700;
  font-size: 16px;
  padding: 7px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f0;
  color: #555;
  margin: 10px;
  transition: all 0.3s ease-out;
  margin-bottom: 25px;
}
</style>
